import { render, staticRenderFns } from "./update-resource-action.vue?vue&type=template&id=257ba611&scoped=true"
import script from "./update-resource-action.vue?vue&type=script&lang=js"
export * from "./update-resource-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257ba611",
  null
  
)

export default component.exports